import PropTypes from 'prop-types';

import { BackendStateWithData } from '../../types';

//////////////////////////////////////////////////////////////////////////////////////////
// Misc shapes
//////////////////////////////////////////////////////////////////////////////////////////
export interface ErrorBoundaryError {
    message: string | null;
    stack: string | null;
    info: string | null;
    showGeneric: boolean;
}

//////////////////////////////////////////////////////////////////////////////////////////
// Redux state shapes
//////////////////////////////////////////////////////////////////////////////////////////
export interface ErrorBoundaryState extends BackendStateWithData<Readonly<ErrorBoundaryError>> {}

//////////////////////////////////////////////////////////////////////////////////////////
// Action Prop Types shapes
//////////////////////////////////////////////////////////////////////////////////////////
export const ActionPropTypes = PropTypes.shape({
    setError: PropTypes.func.isRequired,
    sendErrorRequest: PropTypes.func.isRequired,
    sendErrorSuccess: PropTypes.func.isRequired,
    sendErrorFailure: PropTypes.func.isRequired,
}).isRequired;

//////////////////////////////////////////////////////////////////////////////////////////
// Api response shapes
//////////////////////////////////////////////////////////////////////////////////////////
